import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MEETING_ACCESS_OPTIONS } from "../../../utils/constants";
import {
  PRE_ACTIVATION_FIELD_ACCESS_NOT_READY,
  PRE_ACTIVATION_FIELD_MEETING_ACCESS,
  PRE_ACTIVATION_HINT_ACCESS_NOT_READY,
  PRE_ACTIVATION_MEETING_INTRO,
  PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY,
} from "../../../i18n/keysTranslations";
import CheckGroup from "../components/CheckGroup";
import FieldBlock from "../components/FieldBlock";
import FieldError from "../components/FieldError";
import FieldHint from "../components/FieldHint";
import FieldLabel from "../components/FieldLabel";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const MeetingAccessSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const meetingAccessOptions = useMemo(
    () =>
      MEETING_ACCESS_OPTIONS.map((o) => ({
        value: o.value,
        label: t(o.labelKey),
      })),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      {!readOnly && (
        <Typography
          sx={{
            fontSize: "13px",
            color: "text.secondary",
            lineHeight: 1.6,
            marginBottom: "20px",
          }}
        >
          {t(PRE_ACTIVATION_MEETING_INTRO)}
        </Typography>
      )}

      <FieldBlock>
        <FieldLabel
          htmlFor="meetingAccess"
          text={t(PRE_ACTIVATION_FIELD_MEETING_ACCESS)}
          required
        />
        <Controller
          name="meetingAccess"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CheckGroup
                name="meetingAccess"
                options={meetingAccessOptions}
                selectedValues={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="accessNotReady"
          text={t(PRE_ACTIVATION_FIELD_ACCESS_NOT_READY)}
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_ACCESS_NOT_READY)} />
        <IntakeTextField
          name="accessNotReady"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          multiline
          minRows={4}
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY)}
          variant="outlined"
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default MeetingAccessSection;
